import { useBadgeQuery } from '../../../../contexts/BadgeResourceContext';
import { listChatNotesByUrl } from '../../../../api/chatNotes';

const BADGE_FETCH_LIMIT = 50;
const BADGE_MAX_COUNT = 99;

const useChatNotesBadgeCount = ({ ownerId, buildListUrl, enabled = true }) => {
  const canFetch = enabled && Boolean(ownerId) && typeof buildListUrl === 'function';
  const firstUrl = canFetch ? buildListUrl(ownerId, 0, BADGE_FETCH_LIMIT) : '';
  const { data: noteCount, refresh: refreshNoteCount } = useBadgeQuery({
    queryKey: ['chat-note-count', firstUrl],
    enabled: canFetch,
    initialValue: 0,
    queryFn: async ({ signal }) => {
      const buildUrl = buildListUrl;
      let total = 0;
      let hasMore = true;
      while (hasMore && total <= BADGE_MAX_COUNT) {
        signal.throwIfAborted();
        const json = await listChatNotesByUrl(buildUrl(ownerId, total, BADGE_FETCH_LIMIT));
        signal.throwIfAborted();
        if (!Array.isArray(json?.notes)) throw new Error('Invalid chat note list');
        total += json.notes.length;
        hasMore = json.notes.length === BADGE_FETCH_LIMIT;
      }
      return total > BADGE_MAX_COUNT ? BADGE_MAX_COUNT + 1 : total;
    },
  });
  return { noteCount, refreshNoteCount };
};

export default useChatNotesBadgeCount;
